import {MonthlyBonus} from '../models/payroll-currency.model';
import {salaryDescriptionText} from '../models/salary-description';
import { Injectable } from "@angular/core";
import {
  Http,
  Headers,
  RequestOptions,
  ResponseContentType,
  RequestOptionsArgs
} from "@angular/http";
import { ApiConnectService } from "./api-connect.service";
import { Report } from "../models/report.model";
import { FullUser } from "../models/full-user.model";
import { Group } from "../models/group.model";
import {HeadReadiness} from '../models/head-readiness.model';
import { GroupContext } from "../models/group-context.model";
import { CreatingStandard } from "../models/creating-standard.model";
import { Standard } from "../models/standard.model";
import {DistributedStandard, StandardDistributionRequest} from '../models/standard-distribution.model';
import {StandardFamiliarizationUser} from '../models/standard-user.model';
import { NewBlank } from "../models/new-blank.model";
import { MultiQuestions } from "../models/multi-questions";
import { DisseminationModel } from "../models/dissemination.model";
import { Blank } from "../models/blank.model";
import { Question } from "../models/question.model";
import { Status } from "../models/status.model";
import { HttpClient, HttpHeaders, HttpParams, HttpResponse } from "@angular/common/http";
import { UserService } from "./user.service";
import { Observable } from "rxjs";
import "rxjs/add/operator/catch";
import { CalendarDayResponse } from "../models/calendar-day.model";
import { GeneralSetting } from "../models/general-setting.model";
import { LearningRegionalPercentageSettings } from "../models/learning-regional-percentage.model";
import {
  CalendarMarker,
  CalendarMarkerArchiveRequest,
  CalendarMarkerCreateRequest,
  CalendarMarkerGroup,
  CalendarMarkerGroupsRequest,
  CalendarMarkerUpdateRequest
} from "../models/calendar-marker.model";
import { StandardAiQuestionGenerationStatus } from "../models/standard-ai-question-generation.model";
import {
  AdminSalaryUpdateRequest,
  CurrencyCode,
	DepartmentPayrollCurrencyUpdateResponse,
  PayrollCurrencySettings,
  SalaryContext
} from "../models/payroll-currency.model";
import {
  VacationGroupPresenceResponse,
  VacationPolicy,
  VacationPolicyUpdateRequest
} from "../content-page/common/vacation/vacation.models";
import { GroupResponse, UserInfoBody, StandardCatalogQuery, StandardCatalogPage } from "./admin.service.types";
import {EditableUserProfile, UserRevisionSnapshot, UserUpdatePayload} from '../models/user-profile-snapshot.model';
import {readProfileUser, readProfileGroups} from './user-profile-snapshot';
import 'rxjs/add/operator/concatMap';
import { StandardVersionSnapshot, standardVersionBody, standardVersionHeaders, standardResponseWithVersion, trackStandardVersion } from './standard-version';
import {StandardTranslationSnapshot} from '../models/standard-translation.model';
import { VectorUserListResponse } from '../content-page/views/view-group/view-group.types';

const CATALOG_PAGE = 'page';
const CATALOG_SIZE = 'size';
const CATALOG_PAGE_SIZE = '15';
const CATALOG_SORT = 'sort';
const CATALOG_VALUE = 'value';
const CATALOG_STATUS = 'status';
const CATALOG_PINNED = 'pinnedOnly';

const ROSTER_SCOPE_QUERY = 'includeSubdepartments';
const VECTOR_ROSTER_PATH = '/users/vector';
const PUBLIC_VECTOR_ROSTER_PATH = '/users/without_salary/vector';
const GROUP_ROSTER_BASE = 'backend/common/group/';

const STANDARD_TRANSLATE_PATH = '/translate';
const STANDARD_TRANSLATE_QUESTIONS_PATH = '/translate/questions/';
const STANDARD_AUTHORING_ACCESS_PATH = '/authoring-access';

const STANDARD_GROUP_PATH = '/group/';
const STANDARD_QUESTIONS_PATH = '/questions';
const STANDARD_DEACTIVATE_PATH = '/deactivate';
const STANDARD_QUESTION_PARAMS = { standard: 'sid', language: 'lang' };
const STANDARD_CREATION_QUERY = { separator: '?', heads: 'applyOnlyHeads', allUsers: 'false' };
const STANDARD_MULTIPART = { name: 'name', number: 'number', file: 'file' };
const HTTP_OBSERVE_RESPONSE = "response";
const DEPARTMENT_PAYROLL_CURRENCY_PATH = "/payroll-currency";
const GROUP_CONTEXT_PATH = "/context";
const STANDARD_FILE_PREPARE_PATH = '/prepare';
const HTTP_RESPONSE_TEXT = 'text';
const STANDARD_DISTRIBUTE_PATH = '/distribute';
const STANDARD_USER_PATH = '/user/';
const STANDARD_FILE_LINK_PARAM = 'link';
const STANDARD_FILE_ID_PARAM = 'sid';
const GROUP_SETTINGS_JSON_HEADERS = new HttpHeaders({Accept: 'application/json'});
const GROUP_HEADS_PATH = '/setheads';
const HEAD_CANDIDATE_BASE_PATH = '/common/api/v3/groups/';
const HEAD_CANDIDATE_SEGMENT = '/head-candidates/';
const HEAD_CANDIDATE_PREPARATION_SEGMENT = '/preparation';
const DEPARTMENT_MARKER_PATH = '/department-marker';
const SUGGESTION_CONTEXT_QUERY = 'suggestionId';

// import {cyrillicToTranslit} from '../../../node_modules/cyrillic-to-translit-js';

// const cyrillicToTranslit = require('cyrillic-to-translit-js');
// import {cyrillicToTranslit} from 'cyrillic-to-translit-js';
// import {cyrillicToTranslit} from '../../../node_modules/cyrillic-to-translit-js/CyrillicToTranslit.d';

const MONTHLY_BONUS_PATH = '/monthly-bonus';
const SALARY_PATH = '/salary';
const SALARY_QUERY_PARAMS = {user: 'userID', salary: 'salary', description: 'description'};

@Injectable()
export class AdminService {
  // *** Here all the functionality of the administrator ***;
  constructor(
    private http: HttpClient,
    private userService: UserService,
    private apiURL: ApiConnectService
  ) {}

  getTempDocxFileLink(fid, sid) {
    const header = new HttpHeaders({
      fid: fid,
      sid: sid
    });

    return this.http.get(this.apiURL.getTempFileLink, {
      headers: header,
      responseType: "text",
      observe: "response"
    });
  }

  prepareStandardDocx(fileId: string, snapshot: StandardVersionSnapshot): Observable<HttpResponse<string>> {
    const headers = new HttpHeaders({fid: fileId, sid: snapshot.id});
    return trackStandardVersion(snapshot, this.http.post(this.apiURL.getTempFileLink + STANDARD_FILE_PREPARE_PATH, null, {
      headers: standardVersionHeaders(snapshot, headers),
      responseType: HTTP_RESPONSE_TEXT,
      observe: HTTP_OBSERVE_RESPONSE
    }));
  }

  deleteTempDocxFileLink(fid) {
    const header = new HttpHeaders({
      fid: fid
    });

    return this.http.delete(this.apiURL.deleteTempFileLink, {
      headers: header,
      observe: "response"
    });
  }

  getMyGroups(id: string) {
    return this.http.get(this.apiURL.getMyGroups + id + '/groups/', {observe: 'response'});
  }

  // Create schedules
  createSchedule(schedule) {
    return this.http.post(this.apiURL.createScheduleHead, schedule, {
      observe: "response"
    });
  }

  // Create position
  createPosition(position, groudID) {
    return this.http.post(
      this.apiURL.createPosition + groudID + "/position",
      position,
      { observe: "response" }
    );
  }

  // Create position (global)
  createPositionGlobal(position) {
    // const newPos = {
    //   "name": position
    // };
    // return this.http.post(this.apiURL.createPosition + groudID + '/position', position, {observe: 'response'});
    return this.http.post(this.apiURL.createPositionGlobal, position, {
      observe: "response"
    });
  }

  setPositionStatus(posId, posStatus) {
    return this.http.patch(
      this.apiURL.changePositionStatus + posId + "/active/" + posStatus,
      null,
      {
        observe: "response"
      }
    );
  }

  // Create fullUser
  createFullUser(user, group, position) {
    // send 3 in 1
    const createUserAllObjects = {
      user,
      group,
      position
    };

    return this.http.post(this.apiURL.createUser, createUserAllObjects, {
      observe: "response"
    });
  }

  // Create group OLD
  // createGroup(group) {
  //   return this.http.post(this.apiURL.createGroup, group, {observe: 'response'});
  // }

  createGroup(group) {
    return this.http.post(this.apiURL.createGroup, group, {
      observe: "response"
    });
  }

  sendFile(file) {
    return this.http.post(this.apiURL.addFileToStandard, file, {
      observe: "response"
    });
  }

  /*
   GETTERS GET
   */
   getLastVector(id) {
    return this.http.get(this.apiURL.lastVector + id, { observe: "response" });
  }

  // getListVectors(groupId, vectorOrders) {
  //   let params = new HttpParams();
  //   vectorOrders.forEach(order => {
  //       params = params.append('vectorOrders', order);
  //   });

  //   return this.http.get(`backend/common/group/${groupId}/users/vector`, { observe: "response", params: params });
  // }

  getListVectors(groupId: string, data: Object, includeSubdepartments = false): Observable<VectorUserListResponse> {
    const url = GROUP_ROSTER_BASE + groupId + VECTOR_ROSTER_PATH;
    return this.http.post<VectorUserListResponse['body']>(url, data,
      { observe: HTTP_OBSERVE_RESPONSE, params: this.rosterScopeParameters(includeSubdepartments) });
  }

  getListVectorsNoSalary(groupId: string, data: Object, includeSubdepartments = false): Observable<VectorUserListResponse> {
    const url = GROUP_ROSTER_BASE + groupId + PUBLIC_VECTOR_ROSTER_PATH;
    return this.http.post<VectorUserListResponse['body']>(url, data,
      { observe: HTTP_OBSERVE_RESPONSE, params: this.rosterScopeParameters(includeSubdepartments) });
  }

  getListLastVector() {
    return this.http.get(this.apiURL.lastVectorListUsers, { observe: "response" });
  }

  getFullVector(id, from, to) {
    return this.http.get(this.apiURL.fullVector + id + '?' + new HttpParams().set('from', String(from)).set('to', String(to)), { observe: "response" });
  }

  getUsersShift(id) {
    return this.http.post(this.apiURL.getShift + id, { observe: "response" });
  }

  getsUsersShift() {
    return this.http.get(this.apiURL.getShiftget, { observe: "response" });
  }

  pullShift(param) {
    return this.http.post(this.apiURL.pullShift, param, { observe: "response" });
  }

  getFullVectorAll(from, to) {
    return this.http.get(this.apiURL.fullVectorAll + '?' + new HttpParams().set('from', String(from)).set('to', String(to)), { observe: "response" });
  }

  getAllFullUsers() {
    return this.http.get(this.apiURL.getAllUsers, { observe: "response" });
  }

  getSchedules() {
    return this.http.get(this.apiURL.getAllSchedules, { observe: "response" });
  }

  postiruem(id, tumbler) {
    return this.http.post(this.apiURL.postiruem + id + '?' + new HttpParams().set("tumbler", tumbler), { observe: "response" });
  }

  postiruemOver(id, tumbler) {
    return this.http.post(this.apiURL.postiruemOver + id + '?' + new HttpParams().set("tumbler", tumbler), { observe: "response" });
  }

  outsorce(id, tumbler) {
    return this.http.post(this.apiURL.outsorce + id + '?' + new HttpParams().set("tumbler", tumbler), { observe: "response" });
  }

  getAllGroups() {
    return this.http.get(this.apiURL.getAllGroups, { observe: "response" });
  }

  getAllGroupsForList() {
    return this.http.get(this.apiURL.getAllGroupsForStandartList, { observe: "response" });
  }

  getStaffedGroupOptions(): Observable<HttpResponse<GroupResponse[]>> {
    return this.http.get<GroupResponse[]>(
      this.apiURL.staffedGroupOptions,
      { observe: HTTP_OBSERVE_RESPONSE }
    );
  }

  getAdminGroupOptions(): Observable<HttpResponse<GroupResponse[]>> {
    return this.http.get<GroupResponse[]>(
      this.apiURL.getGroups,
      { observe: HTTP_OBSERVE_RESPONSE }
    );
  }

  getStaffedGroupUserOptions(groupId) {
    return this.http.get(this.apiURL.staffedGroupUserOptions + groupId + '/users/options', { observe: "response" });
  }

  getAllGroupsForListMap(id) {
    return this.http.get(this.apiURL.getAllGroupsForStandartListMap + id, { observe: "response" });
  }

  getAllGroupsAll() {
    return this.http.get(this.apiURL.getAllGroupsHeadAll, { observe: "response" });
  }


  getAllGroupsHead() {
    return this.http.get(this.apiURL.getAllGroupsHead, { observe: "response" });
  }

  getAllGroupsHeadPlanfix(suggestionId?: string) {
    const params = suggestionId ? new HttpParams().set(SUGGESTION_CONTEXT_QUERY, suggestionId) : new HttpParams();
    return this.http.get(this.apiURL.getAllGroupsHeadPlanfix, {
      observe: HTTP_OBSERVE_RESPONSE, params: params
    });
  }

  getDepartmentGroups() {
    return this.http.get(this.apiURL.getDepartmentGroups, {
      observe: "response"
    });
  }

  getAffiliateGroups() {
    return this.http.get(this.apiURL.getAffiliateGroups, {
      observe: "response"
    });
  }

  getGlobalGroups() {
    return this.http.get(this.apiURL.getGlobalGroups, { observe: "response" });
  }

  getAllPositions() {
    // GET POSITIONS FROM GROUP
    return this.http.get(this.apiURL.getAllPositions, {
      observe: "response"
    });
  }

  getActivePositions() {
    const params = new HttpParams().set("active", "true");
    return this.http.get(this.apiURL.getAllPositions, {
      observe: "response",
      params: params
    });
  }

  getGroupByID(groupId: string | number): Observable<HttpResponse<Group>> {
    return this.http.get<Group>(this.apiURL.getGroupById + groupId, {
      observe: HTTP_OBSERVE_RESPONSE
    });
  }

  getGroupContext(groupId: string | number): Observable<HttpResponse<GroupContext>> {
    return this.http.get<GroupContext>(this.apiURL.groupContext + encodeURIComponent(String(groupId)) + GROUP_CONTEXT_PATH,
      { observe: HTTP_OBSERVE_RESPONSE });
  }

  deleteEvent(groupID) {
    return this.http.delete(this.apiURL.deleteEvent + groupID, {
      observe: "response"
    });
  }

  checkLevel(id) {
    return this.http.get(this.apiURL.checkLevel + id, {observe: 'response'});
  }

  pushTask(id) {
    return this.http.post(this.apiURL.pushTask + id, null);
  }

  getStandardCatalog(query: StandardCatalogQuery): Observable<HttpResponse<StandardCatalogPage>> {
    let params = new HttpParams().set(CATALOG_PAGE, String(query.page)).set(CATALOG_SIZE, CATALOG_PAGE_SIZE)
      .set(CATALOG_SORT, query.sort).set(CATALOG_VALUE, query.value).set(CATALOG_PINNED, String(query.pinnedOnly));
    if (query.status) { params = params.set(CATALOG_STATUS, query.status); }
    return this.http.get<StandardCatalogPage>(this.apiURL.getAllStandards, {observe: HTTP_OBSERVE_RESPONSE, params: params});
  }

  // GET ALL STANDARDS
  getAllStandards() {
    let page: string;
    if (localStorage.getItem("lastPage")) {
      page = (Number(localStorage.getItem("lastPage")) - 1).toString();
    } else {
      page = "0";
    }
    const parameters = {
      page: page,
      sort: "number,asc",
      size: "15",
      value: ""
    };

    const params = new HttpParams()
      .set("page", parameters.page)
      .set("sort", parameters.sort)
      .set("size", parameters.size)
      .set("value", parameters.value);

    return this.http.get(this.apiURL.getAllStandards, {
      observe: "response",
      params: params
    });
  }

  getAllStandardsById(id) {
    let page: string;
    if (localStorage.getItem("lastPage")) {
      page = (Number(localStorage.getItem("lastPage")) - 1).toString();
    } else {
      page = "0";
    }
    const parameters = {
      page: page,
      sort: "number,asc",
      size: "15",
      value: ""
    };

    const params = new HttpParams()
      .set("page", parameters.page)
      .set("sort", parameters.sort)
      .set("size", parameters.size)
      .set("value", parameters.value);

    return this.http.get(this.apiURL.getAllStandardsId + id, {
      observe: "response",
      params: params
    });
  }

  getPageServera(id, page, searchValue, status, sortId) {
    const parameters = {
      page: page,
      sort: sortId,
      size: "15",
      status: status,
      value: searchValue
    };

    let params = new HttpParams()
      .set("page", parameters.page)
      .set("sort", parameters.sort)
      .set("size", parameters.size)
      .set("value", searchValue);

    if (status !== "") {
      params = params.set("status", parameters.status);
    }

  return this.http.get(this.apiURL.getAllStandardsId + id, {
    observe: "response",
    params: params
  });
}

  // GET ALL STANDARDS
  getAllStandardsGroup() {
    return this.http.get(this.apiURL.getAllStandards, { observe: "response" });
  }

  // getAllStandardsWithoutSort
  getAllStandardsGroupWithoutSort() {
    return this.http.get(this.apiURL.getAllStandardsWithoutSort, {
      observe: "response"
    });
  }

  // STANDARD SEARCH
  getAllStandardsByValue(searchValue) {
    const parameters = {
      page: "0",
      sort: "number,asc",
      size: "15",
      value: searchValue
    };

    const params = new HttpParams()
      .set("page", parameters.page)
      .set("sort", parameters.sort)
      .set("size", parameters.size)
      .set("value", searchValue);

    return this.http.get(this.apiURL.getAllStandards, {
      observe: "response",
      params: params
    });
  }

  // GET FILTERED STANDARDS
  getFilteredStandards(searchValue, status) {
    const parameters = {
      page: "0",
      sort: "number,asc",
      size: "15",
      status: status,
      value: searchValue
    };

    let params = new HttpParams()
      .set("page", parameters.page)
      .set("sort", parameters.sort)
      .set("size", parameters.size)
      .set("value", parameters.value);

    if (status !== "") {
      params = params.set("status", parameters.status);
    }

    return this.http.get(this.apiURL.getAllStandards, {
      observe: "response",
      params: params
    });
  }

  // GET SORTED STANDARDS
  getSortedStandards(currentPage, sortId, searchValue, status) {
    const parameters = {
      page: currentPage,
      sort: sortId,
      size: "15",
      status: status,
      value: searchValue
    };

    let params = new HttpParams()
      .set("page", parameters.page)
      .set("sort", parameters.sort)
      .set("size", parameters.size)
      .set("value", parameters.value);

    if (status !== "") {
      params = params.set("status", parameters.status);
    }

    return this.http.get(this.apiURL.getAllStandards, {
      observe: "response",
      params: params
    });
  }

  // GET DATA FROM PAGE
  getPageServer(page, searchValue, status, sortId) {
    const parameters = {
      page: page,
      sort: sortId,
      size: "15",
      status: status,
      value: searchValue
    };

    let params = new HttpParams()
      .set("page", parameters.page)
      .set("sort", parameters.sort)
      .set("size", parameters.size)
      .set("value", searchValue);

    if (status !== "") {
      params = params.set("status", parameters.status);
    }

    return this.http.get(this.apiURL.getAllStandards, {
      observe: "response",
      params: params
    });
  }

  getUserOutSide(groupID) {
    return this.http.get(this.apiURL.getUsersOutsideOfGroup + groupID, {
      observe: "response"
    });
  }

  putUserOfGroup(groupID, userID, positionID) {
    return this.http.patch(
      this.apiURL.putUserOfGroup +
        groupID +
        "/adduser/" +
        userID +
        "/" +
        positionID,
      null,
      { observe: "response" }
    );
  }

  getHeadReadiness(groupID: string, userID: string): Observable<HeadReadiness> {
    return this.http.get<HeadReadiness>(this.headCandidateUrl(groupID, userID));
  }

  startHeadPreparation(groupID: string, userID: string): Observable<HeadReadiness> {
    return this.http.post<HeadReadiness>(this.headCandidateUrl(groupID, userID) + HEAD_CANDIDATE_PREPARATION_SEGMENT, {});
  }

  private headCandidateUrl(groupID: string, userID: string): string {
    return this.apiURL.baseApiUrl + HEAD_CANDIDATE_BASE_PATH + encodeURIComponent(groupID)
      + HEAD_CANDIDATE_SEGMENT + encodeURIComponent(userID);
  }

  setHeadsForGroup(groupID: string, selection: {headId: string | null, deputyId: string | null,
                                             taskNotRequired?: boolean}) {
    return this.http.patch<Group>(
      this.apiURL.setHeadsForGroup +
        groupID +
        GROUP_HEADS_PATH,
      selection,
      { observe: HTTP_OBSERVE_RESPONSE, headers: GROUP_SETTINGS_JSON_HEADERS }
    );
  }

  changeKarma(group) {
    return this.http.patch(this.apiURL.changeKarmaUser, group, {
      observe: "response"
    });
  }

  changeEmploy(id, group) {
    return this.http.post(`/backend/common/head/user/${id}/date_of_employment` + '?' + new HttpParams().set("dateOfEmployment", group), {
      observe: "response"
    });
  }


  changeVector(id, valueOne, valueTwo, valueThree, valueFour, valueFive) {
    let stringVector = valueOne + ',' + valueTwo + ',' + valueThree + ',' + valueFour + ',' + valueFive;
    return this.http.post(this.apiURL.changeVector + '?' + new HttpParams().set("userID", id).set("components", stringVector),  {
      observe: "response"
    });
  }


  changeUserStatusInGroup(groupID, userID, status: string) {
    const header = new HttpHeaders({
      "current-status": status
    });

    return this.http.patch(
      this.apiURL.changeUserStatusInGroup + groupID + "/" + userID + "/status",
      null,
      {
        headers: header,
        observe: "response"
      }
    );
  }

  updateUser<T extends UserRevisionSnapshot>(payload: UserUpdatePayload<T>): Observable<HttpResponse<T>> {
    return this.http.patch<T>(this.apiURL.updateUser, payload, {
      observe: HTTP_OBSERVE_RESPONSE
    });
  }

  getUserProfileSnapshot(userId: string): Observable<UserUpdatePayload> {
    return this.userService.getUserFromAPI(userId)
      .map(response => readProfileUser(response as HttpResponse<EditableUserProfile>, userId))
      .concatMap(user => this.getUserInfo(userId)
        .map(response => readProfileGroups(user, response as HttpResponse<UserInfoBody>)));
  }

  getKarmaInfo(userId, from, to) {
    return this.http.get(this.apiURL.getKarmaInfo + '?' + new HttpParams().set('userId', userId).set('from', from).set('to', to), {
      observe: "response",
    });
  }

  getChtoto(id) {
    return this.http.get(this.apiURL.getChtoto + id, {
      observe: "response",
    });
  }

  getWorkDays(userId, from, to) {
    return this.http.get<HttpResponse<any>>(`/backend/common/user/${userId}/working_dey` + '?' + new HttpParams().set('from', from).set('to', to), {
      observe: 'response'
    });
  }

  getExcelReport(reports: Report[], groupName: string) {
    return this.http.put(
      this.apiURL.getExcelReport + "?group_name=" + groupName,
      reports,
      {
        responseType: "blob",
        observe: "response"
      }
    );
  }

  updateGroup(group) {
    return this.http.patch(this.apiURL.updateGroup, group, {
      observe: "response"
    });
  }

  convertGroup(group, type) {
    return this.http.patch(this.apiURL.convertGroup + type, group, {
      observe: "response"
    });
  }

  addRelative(group) {
    return this.http.patch(this.apiURL.addRelative, group, {
      observe: "response"
    });
  }

  /*
   UPDATERS PATCH
   */

  getStandard(standardId) {
    const reqHeaders = new HttpHeaders({
      offset: this.userService.getTimezoneOffset()
    });
    return this.http.get<Standard>(this.apiURL.getStandard + standardId, {
      observe: HTTP_OBSERVE_RESPONSE,
      headers: reqHeaders
    }).map(standardResponseWithVersion);
  }

  getStandardAuthoringAccess(standardId: string): Observable<HttpResponse<boolean>> {
    return this.http.get<boolean>(this.apiURL.getStandard + standardId + STANDARD_AUTHORING_ACCESS_PATH, {
      observe: HTTP_OBSERVE_RESPONSE
    });
  }

  getStandardAiQuestionStatus(standardId: string, language: string): Observable<HttpResponse<StandardAiQuestionGenerationStatus>> {
    return this.http.get<StandardAiQuestionGenerationStatus>(
      this.apiURL.standardAiQuestions + standardId + "/ai/questions/" + language + "/status",
      { observe: "response" }
    );
  }

  generateStandardAiQuestions(standardId: string, language: string): Observable<HttpResponse<StandardAiQuestionGenerationStatus>> {
    return this.requestStandardAiQuestionGeneration(standardId, language, "false");
  }

  forceGenerateStandardAiQuestions(standardId: string, language: string): Observable<HttpResponse<StandardAiQuestionGenerationStatus>> {
    return this.requestStandardAiQuestionGeneration(standardId, language, "true");
  }

  generateDraftStandardAiQuestions(request: FormData, language: string): Observable<HttpResponse<StandardAiQuestionGenerationStatus>> {
    return this.http.post<StandardAiQuestionGenerationStatus>(
      this.apiURL.standardAiQuestions + "ai/questions/" + language + "/draft",
      request,
      { observe: "response" }
    );
  }

  generateExistingStandardDraftAiQuestions(standardId: string, language: string): Observable<HttpResponse<StandardAiQuestionGenerationStatus>> {
    return this.http.post<StandardAiQuestionGenerationStatus>(
      this.apiURL.standardAiQuestions + standardId + "/ai/questions/" + language + "/draft",
      null,
      { observe: "response" }
    );
  }

  private requestStandardAiQuestionGeneration(
    standardId: string,
    language: string,
    force: string
  ): Observable<HttpResponse<StandardAiQuestionGenerationStatus>> {
    const params = new HttpParams().set("force", force);
    return this.http.post<StandardAiQuestionGenerationStatus>(
      this.apiURL.standardAiQuestions + standardId + "/ai/questions/" + language + "/generate",
      null,
      { observe: "response", params: params }
    );
  }

  getStandardTemp(standardId) {
    return this.http.get(this.apiURL.getStandard + standardId + "/tmp", {
      observe: "response"
    });
  }

  getTempStandard(standardId) {
    return this.http.get(this.apiURL.getTempStandard + standardId + "/tmp", {
      observe: "response"
    });
  }

  createStandard(standard: CreatingStandard, applyOnlyHeads) {
    return this.http.post(this.apiURL.createStandard  + '?' + new HttpParams().set('applyOnlyHeads', applyOnlyHeads) , standard, {
      observe: "response"
    });
  }

  createHeadStandard(standard: CreatingStandard) {
    return this.http.post<Standard>(this.apiURL.createHeadStandard, standard, {
      observe: HTTP_OBSERVE_RESPONSE
    }).map(standardResponseWithVersion);
  }

  createStandardd(standard: CreatingStandard) {
    const params = new HttpParams().set(STANDARD_CREATION_QUERY.heads, STANDARD_CREATION_QUERY.allUsers);
    return this.http.post<Standard>(this.apiURL.createStandard + STANDARD_CREATION_QUERY.separator + params, standard, {
      observe: HTTP_OBSERVE_RESPONSE
    }).map(standardResponseWithVersion);
  }

  notifyIsView(param) {
    return this.http.patch(this.apiURL.markNotify, param, {
      observe: "response"
    });
  }

  notifyIsViewNot(param) {
    return this.http.patch(this.apiURL.markNotifyNot, param, {
      observe: "response"
    });
  }


  addQuestionsToStandard(questions: MultiQuestions, standard: StandardVersionSnapshot) {
    const headers = new HttpHeaders({
      id: standard.id
    });
    return trackStandardVersion(standard, this.http.post(this.apiURL.addQuestionToStandardById, questions, {
      headers: standardVersionHeaders(standard, headers),
      observe: HTTP_OBSERVE_RESPONSE
    }));
  }

  editQuestionInStandard(
    combinedQuestions: Object,
    standard: StandardVersionSnapshot,
    questionLang: string
  ) {
    const params = new HttpParams().set(STANDARD_QUESTION_PARAMS.standard, standard.id).set(STANDARD_QUESTION_PARAMS.language, questionLang);
    return trackStandardVersion(standard, this.http.post(
      this.apiURL.editQuestionInStandard,
      standardVersionBody(standard, combinedQuestions),
      {
        params,
        observe: HTTP_OBSERVE_RESPONSE
      }
    ));
  }

  setTempQuestionsForStandard(standard: StandardVersionSnapshot, questionsBody: MultiQuestions) {
    return trackStandardVersion(standard, this.http.patch<MultiQuestions>(
      this.apiURL.setTempQuestionsForStandard + standard.id + STANDARD_QUESTIONS_PATH,
      questionsBody,
      { observe: HTTP_OBSERVE_RESPONSE, headers: standardVersionHeaders(standard) }
    ));
  }

  rusToLatin(str) {
    const ru = {
        а: "a",
        б: "b",
        в: "v",
        г: "g",
        д: "d",
        е: "e",
        ё: "e",
        ж: "j",
        з: "z",
        и: "i",
        к: "k",
        л: "l",
        м: "m",
        н: "n",
        о: "o",
        п: "p",
        р: "r",
        с: "s",
        т: "t",
        у: "u",
        ф: "f",
        х: "h",
        ц: "c",
        ч: "ch",
        ш: "sh",
        щ: "shch",
        ы: "y",
        э: "e",
        ю: "u",
        я: "ya"
      },
      n_str = [];

    str = str.replace(/[ъь]+/g, "").replace(/й/g, "i");

    for (let i = 0; i < str.length; ++i) {
      n_str.push(
        ru[str[i]] ||
          (ru[str[i].toLowerCase()] === undefined && str[i]) ||
          ru[str[i].toLowerCase()].replace(/^(.)/, function(match) {
            return match.toUpperCase();
          })
      );
    }

    return n_str.join("");
  }

  uploadFiles(standard, formData: FormData) {
    // .doc      application/msword
    // .docx     application/vnd.openxmlformats-officedocument.wordprocessingml.document
    // .ppt      application/vnd.ms-powerpoint
    // .pptx     application/vnd.openxmlformats-officedocument.presentationml.presentation

    const headers = new HttpHeaders({
      id: standard.id
    });



    return trackStandardVersion(standard, this.http.post(this.apiURL.uploadFile, formData, {
      headers: standardVersionHeaders(standard, headers),
      observe: HTTP_OBSERVE_RESPONSE
    }));
  }

  uploadFilesTemp(standardID, formData, snapshot?: StandardVersionSnapshot) {
    const headers = new HttpHeaders({
      id: standardID
    });
    return trackStandardVersion(snapshot, this.http.post(this.apiURL.uploadFileTemp, formData, {
      headers: standardVersionHeaders(snapshot, headers),
      observe: HTTP_OBSERVE_RESPONSE
    }));
  }

  uploadBlank(standard, blanks: NewBlank[]) {
    const headers = new HttpHeaders({
      id: standard.id
    });

    const formData: FormData = new FormData();

    for (const blank of blanks) {
      formData.append(STANDARD_MULTIPART.name, blank.name);
      formData.append(STANDARD_MULTIPART.number, blank.number);
      formData.append(STANDARD_MULTIPART.file, blank.formData.get(STANDARD_MULTIPART.file));
    }

    return trackStandardVersion(standard, this.http.post(this.apiURL.uploadBlank, formData, {
      headers: standardVersionHeaders(standard, headers),
      observe: HTTP_OBSERVE_RESPONSE
    }));
  }

  uploadBlankTemp(standardID, blanks: NewBlank[], snapshot?: StandardVersionSnapshot) {
    const headers = new HttpHeaders({
      id: standardID
    });

    const formData: FormData = new FormData();
    for (const blank of blanks) {
      formData.append(STANDARD_MULTIPART.name, blank.name);
      formData.append(STANDARD_MULTIPART.number, blank.number);
      formData.append(STANDARD_MULTIPART.file, blank.formData.get(STANDARD_MULTIPART.file));
    }
    return trackStandardVersion(snapshot, this.http.post(this.apiURL.uploadBlankTemp, formData, {
      headers: standardVersionHeaders(snapshot, headers),
      observe: HTTP_OBSERVE_RESPONSE
    }));
  }

  disseminateStandard(dissemination: StandardDistributionRequest,
                      snapshot: StandardVersionSnapshot): Observable<HttpResponse<DistributedStandard>> {
    return trackStandardVersion(snapshot, this.http.patch<DistributedStandard>(
      this.apiURL.disseminateStandardNew + snapshot.id + STANDARD_DISTRIBUTE_PATH,
      standardVersionBody(snapshot, dissemination), { observe: HTTP_OBSERVE_RESPONSE }
    )).map(standardResponseWithVersion);
  }

  deleteBlankFromStandard(blank, standard) {
    const headers = new HttpHeaders({
      sid: standard.id,
      bid: blank.fileId
    });
    return trackStandardVersion(standard, this.http.delete(this.apiURL.deleteBlankFromStandard, {
      headers: standardVersionHeaders(standard, headers),
      observe: HTTP_OBSERVE_RESPONSE
    }));
  }

  deleteBlankFromStandardTemp(blank, standardID) {
    const headers = new HttpHeaders({
      sid: standardID,
      bid: blank.fileId
    });
    return this.http.delete(this.apiURL.deleteBlankFromStandardTemp, {
      headers: headers,
      observe: "response"
    });
  }

  deleteQuestionFromStandard(
    standard: Standard,
    question: Question,
    lang: string
  ) {
    const headers = new HttpHeaders({
      sid: standard.id,
      lang: lang
    });

    return trackStandardVersion(standard, this.http.patch(this.apiURL.deleteQuestion, standardVersionBody(standard, question), {
      headers,
      observe: HTTP_OBSERVE_RESPONSE
    }));
  }

  deleteFileFromStandard(fileId: string, type: string, standard: Standard) {
    const headers = new HttpHeaders({
      sid: standard.id,
      fid: fileId,
      type: type
    });
    return trackStandardVersion(standard, this.http.delete(this.apiURL.deleteFileFromStandard, {
      headers: standardVersionHeaders(standard, headers),
      observe: HTTP_OBSERVE_RESPONSE
    }));
  }

  deleteFileFromStandardTemp(fileId: string, type: string, standardID) {
    const headers = new HttpHeaders({
      sid: standardID,
      fid: fileId,
      type: type
    });
    return this.http.delete(this.apiURL.deleteFileFromStandardTemp, {
      headers: headers,
      observe: "response"
    });
  }

  changeStatus(standard, selectedStatus) {
    const headers = new HttpHeaders({
      sid: standard.id,
      status: selectedStatus
    });
    return trackStandardVersion(standard, this.http.patch(this.apiURL.changeStandardStatus, null, {
      headers: standardVersionHeaders(standard, headers),
      observe: HTTP_OBSERVE_RESPONSE
    }));
  }

  changeStatusToActive(standard: StandardVersionSnapshot, selectedStatus: string) {
    const headers = new HttpHeaders({
      sid: standard.id,
      status: selectedStatus
    });
    return trackStandardVersion(standard, this.http.patch(this.apiURL.changeStandardStatus, null, {
      headers: standardVersionHeaders(standard, headers),
      observe: HTTP_OBSERVE_RESPONSE
    }));
  }

  changeStatusHead(standardID, selectedStatus) {
    const headers = new HttpHeaders({
      sid: standardID,
      status: selectedStatus
    });
    return this.http.patch(this.apiURL.changeStandardStatusHead, null, {
      headers: headers
    });
  }

  changeInitiator(standard: Standard, selectedUser: FullUser) {
    const headers = new HttpHeaders({
      sid: standard.id,
      uid: selectedUser.id
    });
    return trackStandardVersion(standard, this.http.patch(this.apiURL.changeInitiator, null, {
      headers: standardVersionHeaders(standard, headers),
      observe: HTTP_OBSERVE_RESPONSE
    }));
  }

  changeDivision(standard: Standard, selectedDivision: Group) {
    return trackStandardVersion(standard, this.http.put(
      this.apiURL.changeDivision +
        standard.id +
        STANDARD_GROUP_PATH +
        selectedDivision.id,
      null,
      { observe: HTTP_OBSERVE_RESPONSE, headers: standardVersionHeaders(standard) }
    ));
  }

  editStandardInfo(standard: Standard, info: Object) {
    const headers = new HttpHeaders({
      sid: standard.id
    });
    return trackStandardVersion(standard, this.http.patch(this.apiURL.editStandardInfo, info, {
      headers: standardVersionHeaders(standard, headers),
      observe: HTTP_OBSERVE_RESPONSE
    }));
  }

  addQuestionToStandard(standard: Standard, multiQuestion: MultiQuestions) {
    const headers = new HttpHeaders({
      sid: standard.id
    });

    return trackStandardVersion(standard, this.http.put(this.apiURL.addQuestionToStandard, multiQuestion, {
      headers: standardVersionHeaders(standard, headers),
      observe: HTTP_OBSERVE_RESPONSE
    }));
  }

  changeUserPositionInGroup(gid, uid, pid) {
    const headers = new HttpHeaders({
      pid: pid
    });
    return this.http.patch(
      this.apiURL.changeUserPositionInGroup + gid + "/" + uid + "/position",
      null,
      {
        headers: headers,
        observe: "response"
      }
    );
  }

  changeUserPassword(uid, newPass) {
    const headers = new HttpHeaders({
      uid: uid
    });
    return this.http.post(this.apiURL.changeUserPassword, newPass, {
      headers: headers,
      observe: "response"
    });
  }

  changePositionNameInGroup(gid, pid, newName) {
    const headers = new HttpHeaders({
      gid: gid,
      pid: pid
    });
    return this.http.patch(this.apiURL.changePositionNameInGroup, newName, {
      headers: headers,
      observe: "response"
    });
  }

  deletePositionFromGroup(gid, pid) {
    const headers = new HttpHeaders({
      gid: gid,
      pid: pid
    });
    return this.http.delete(this.apiURL.deletePositionFromGroup, {
      headers: headers,
      observe: "response"
    });
  }

  // GET Получить пользователей, на которых не распространяется действие стандарта
  getUsersOusideStandard(standardID) {
    return this.http.get(
      this.apiURL.getStandardOutsidesUsers + standardID + "/out",
      { observe: "response" }
    );
  }

  addUserToStandard(snapshot: StandardVersionSnapshot, userId: string): Observable<HttpResponse<StandardFamiliarizationUser[]>> {
    return trackStandardVersion(snapshot, this.http.put<StandardFamiliarizationUser[]>(
      this.apiURL.addUserToStandard + snapshot.id + STANDARD_USER_PATH + userId, null,
      { observe: HTTP_OBSERVE_RESPONSE, headers: standardVersionHeaders(snapshot) }
    ));
  }

  deleteUserFromStandard(snapshot: StandardVersionSnapshot, userId: string): Observable<HttpResponse<StandardFamiliarizationUser[]>> {
    return trackStandardVersion(snapshot, this.http.delete<StandardFamiliarizationUser[]>(
      this.apiURL.deleteUserFromStandard + snapshot.id + STANDARD_USER_PATH + userId,
      { observe: HTTP_OBSERVE_RESPONSE, headers: standardVersionHeaders(snapshot) }
    ));
  }

  changeStatusDeactivate(standard: StandardVersionSnapshot) {
    // POST Сделать стандарт неактивным
    return trackStandardVersion(standard, this.http.post<Standard>(
      this.apiURL.changeStatusDeactivate + standard.id + STANDARD_DEACTIVATE_PATH,
      null,
      { observe: HTTP_OBSERVE_RESPONSE, headers: standardVersionHeaders(standard) }
    ));
  }

  getChangeLogs(id) {
    // GET Получить список описаний изменений
    return this.http.get(this.apiURL.getChangeLogs + id + "/modify/notes", {
      observe: "response"
    });
  }

  renamePosGlobal(id: string, newName: string) {
    const a = {
      id: id,
      name: newName
    };
    return this.http.patch(this.apiURL.renamePosGlobal, a, {
      observe: "response"
    });
  }

  changeSalaryValue(userId: string, salary: number, description: string): Observable<void> {
    const params = new HttpParams()
      .set(SALARY_QUERY_PARAMS.user, userId)
      .set(SALARY_QUERY_PARAMS.salary, String(salary))
      .set(SALARY_QUERY_PARAMS.description, salaryDescriptionText(description));
    return this.http.post<void>(this.apiURL.changeSalaryValue, {}, { params });
  }

  getSalaryContext(userId: string): Observable<SalaryContext> {
    return this.http.get<SalaryContext>(
      this.apiURL.salaryContext + userId + '/salary-context'
    );
  }

  updateMonthlyBonus(userId: string, request: MonthlyBonus): Observable<SalaryContext> {
    return this.http.put<SalaryContext>(this.apiURL.salaryContext + userId + MONTHLY_BONUS_PATH, request);
  }

  updateHeadSalary(userId: string, request: AdminSalaryUpdateRequest): Observable<SalaryContext> {
    const body = Object.assign({}, request, {description: salaryDescriptionText(request.description)});
    return this.http.put<SalaryContext>(this.apiURL.headSalary + userId + SALARY_PATH, body);
  }

  updateAdminSalary(
    userId: string,
    request: AdminSalaryUpdateRequest
  ): Observable<SalaryContext> {
    return this.http.put<SalaryContext>(
      this.apiURL.adminSalary + userId + SALARY_PATH,
      Object.assign({}, request, {description: salaryDescriptionText(request.description)})
    );
  }

  saveGeneralSettings(data: GeneralSetting): Observable<HttpResponse<GeneralSetting>> {
    return this.http.post<GeneralSetting>(this.apiURL.changeModalSetting, data, { observe: HTTP_OBSERVE_RESPONSE });
  }

  getGeneralSettings(): Observable<HttpResponse<GeneralSetting>> {
    return this.http.get<GeneralSetting>(this.apiURL.changeModalSetting, { observe: HTTP_OBSERVE_RESPONSE });
  }

  changeModalSettings(data: GeneralSetting): Observable<HttpResponse<GeneralSetting>> {
    return this.http.post(this.apiURL.changeModalSetting, data, {
      observe: "response"
    })
      .catch(() => this.saveLegacyModalSettings(data));
  }

  getModalSetting(): Observable<HttpResponse<GeneralSetting>> {
    return this.http.get(this.apiURL.changeModalSetting, {
      observe: "response"
    })
      .catch(() => this.loadLegacyModalSettings());
  }

  getLearningRegionalPercentages(): Observable<HttpResponse<LearningRegionalPercentageSettings>> {
    return this.http.get<LearningRegionalPercentageSettings>(this.apiURL.learningRegionalPercentages, {
      observe: "response"
    });
  }

  updateLearningRegionalPercentages(
    data: LearningRegionalPercentageSettings,
  ): Observable<HttpResponse<LearningRegionalPercentageSettings>> {
    const regions = data.regions || [];
    const stockRegion = regions.filter(region => region.stock)[0];
    const request = {
      ruPercentageOfWagesPerLevel: stockRegion
        ? stockRegion.percentageOfWagesPerLevel
        : data.ruPercentageOfWagesPerLevel,
      regionalPercentages: regions.filter(region => !region.stock),
    };
    return this.http.put<LearningRegionalPercentageSettings>(this.apiURL.learningRegionalPercentages, request, {
      observe: "response"
    });
  }

  getPayrollCurrencySettings(): Observable<PayrollCurrencySettings> {
    return this.http.get<PayrollCurrencySettings>(this.apiURL.payrollCurrencySettings);
  }

  updatePayrollCurrencySettings(
    settings: PayrollCurrencySettings
  ): Observable<PayrollCurrencySettings> {
    return this.http.put<PayrollCurrencySettings>(
      this.apiURL.payrollCurrencySettings,
      settings
    );
  }

  getVacationPolicy(): Observable<VacationPolicy> {
    return this.http.get<VacationPolicy>(this.apiURL.vacationPolicySettings);
  }

  getVacationGroupPresence(
    groupId: string, includeSubdepartments = false
  ): Observable<VacationGroupPresenceResponse> {
    return this.http.get<VacationGroupPresenceResponse>(
      this.apiURL.vacationGroupPresence(groupId), { params: this.rosterScopeParameters(includeSubdepartments) }
    );
  }

  private rosterScopeParameters(includeSubdepartments: boolean): HttpParams {
    return new HttpParams().set(ROSTER_SCOPE_QUERY, String(includeSubdepartments));
  }

  updateVacationPolicy(
    request: VacationPolicyUpdateRequest
  ): Observable<VacationPolicy> {
    return this.http.put<VacationPolicy>(
      this.apiURL.vacationPolicySettings,
      request
    );
  }

  getCalendarMarkers(): Observable<HttpResponse<CalendarMarker[]>> {
    return this.http.get<CalendarMarker[]>(this.apiURL.calendarMarkers, {
      observe: "response"
    });
  }

  createCalendarMarker(request: CalendarMarkerCreateRequest): Observable<HttpResponse<CalendarMarker>> {
    return this.http.post<CalendarMarker>(this.apiURL.calendarMarkers, request, {
      observe: "response"
    });
  }

  updateCalendarMarker(
    markerId: string,
    request: CalendarMarkerUpdateRequest
  ): Observable<HttpResponse<CalendarMarker>> {
    return this.http.patch<CalendarMarker>(this.apiURL.calendarMarkers + "/" + markerId, request, {
      observe: "response"
    });
  }

  archiveCalendarMarker(
    markerId: string,
    request: CalendarMarkerArchiveRequest
  ): Observable<HttpResponse<CalendarMarker>> {
    return this.http.post<CalendarMarker>(this.apiURL.calendarMarkers + "/" + markerId + "/archive", request, {
      observe: "response"
    });
  }

  getCalendarMarkerGroups(): Observable<HttpResponse<CalendarMarkerGroup[]>> {
    return this.http.get<CalendarMarkerGroup[]>(this.apiURL.calendarMarkerGroups, {
      observe: "response"
    });
  }

  replaceCalendarMarkerGroups(markerId: string, groupIds: string[]): Observable<HttpResponse<CalendarMarkerGroup[]>> {
    return this.http.put<CalendarMarkerGroup[]>(
      this.apiURL.calendarMarkers + "/" + markerId + "/groups",
      this.createCalendarMarkerGroupsPayload(groupIds),
      { observe: "response" }
    );
  }

  deleteCalendarMarkerGroup(markerId: string, groupId: string): Observable<HttpResponse<CalendarMarkerGroup>> {
    return this.http.delete<CalendarMarkerGroup>(
      this.apiURL.calendarMarkers + "/" + markerId + "/groups/" + groupId,
      { observe: "response" }
    );
  }

  getListWeekends(from, to, markerId?: string): Observable<HttpResponse<CalendarDayResponse[]>> {
    return this.http.get<CalendarDayResponse[]>(this.apiURL.getListWeekends, {
      observe: "response",
      params: this.buildCalendarDateRangeParams(from, to, markerId)
    });
  }

  markCalendarWeekend(localDate: string, markerId?: string): Observable<HttpResponse<CalendarDayResponse>> {
    return this.saveCalendarDay(localDate, "false", markerId);
  }

  markCalendarHoliday(localDate: string, markerId?: string): Observable<HttpResponse<CalendarDayResponse>> {
    return this.saveCalendarDay(localDate, "true", markerId);
  }

  addWeekends(localDate, type, markerId?: string): Observable<HttpResponse<CalendarDayResponse>> {
    return this.saveCalendarDay(String(localDate), this.resolveCalendarDayType(type), markerId);
  }

  delWeekends(id, markerId?: string): Observable<HttpResponse<void>> {
    return this.http.delete<void>(this.apiURL.delWeekends + id, {
      observe: "response",
      params: this.buildMarkerOnlyParams(markerId)
    });
  }

  private saveCalendarDay(localDate: string, isPublicHoliday: string, markerId?: string): Observable<HttpResponse<CalendarDayResponse>> {
    return this.http.post<CalendarDayResponse>(this.apiURL.addWeekends, null, {
      observe: "response",
      params: this.buildCalendarDayParams(localDate, isPublicHoliday, markerId)
    });
  }

  private createCalendarMarkerGroupsPayload(groupIds: string[]): CalendarMarkerGroupsRequest {
    return {
      groupIds: groupIds
    };
  }

  private buildCalendarDateRangeParams(from, to, markerId?: string): HttpParams {
    const params = new HttpParams().set("from", String(from)).set("to", String(to));
    return this.appendMarkerId(params, markerId);
  }

  private buildCalendarDayParams(localDate: string, isPublicHoliday: string, markerId?: string): HttpParams {
    const params = new HttpParams().set("localDate", localDate).set("isPublicHoliday", isPublicHoliday);
    return this.appendMarkerId(params, markerId);
  }

  private buildMarkerOnlyParams(markerId?: string): HttpParams {
    return this.appendMarkerId(new HttpParams(), markerId);
  }

  private appendMarkerId(params: HttpParams, markerId?: string): HttpParams {
    if (!markerId) {
      return params;
    }
    return params.set("markerId", markerId);
  }

  private resolveCalendarDayType(type): string {
    if (type === true || type === "true" || type === 1 || type === "1") {
      return "true";
    }
    return "false";
  }

  getQuestionForTranslateByStandardID(urlID: string) {
    return this.http.get(
      this.apiURL.getQuestionForTranslateByStandardID +
        urlID +
        "/translate/questions",
      { observe: "response" }
    );
  }

  getStandardBaseLanguageByID(sID: string) {
    return this.http.get(this.apiURL.getStandardBaseLanguageByID + sID, {
      responseType: "text",
      observe: "response"
    });
    // {responseType: 'text'}
  }

  translateStandardMainInfoRequest(sID: string) {
    return this.http.get<number>(this.apiURL.translatedMainInfo + sID, {
      observe: HTTP_OBSERVE_RESPONSE
    });
  }

  doneStandardMainInfo(snapshot: StandardVersionSnapshot, standard) {
    return trackStandardVersion(snapshot, this.http.put(
      this.apiURL.doneStandardMainInfo + snapshot.id + STANDARD_TRANSLATE_PATH,
      standardVersionBody(snapshot, standard),
      { observe: HTTP_OBSERVE_RESPONSE }
    ));
  }

  doneTranslateQuestions(snapshot: StandardVersionSnapshot, questionsList) {
    return trackStandardVersion(snapshot, this.http.put(
      this.apiURL.doneTranslateQuestions + snapshot.id + STANDARD_TRANSLATE_QUESTIONS_PATH,
      questionsList,
      { observe: HTTP_OBSERVE_RESPONSE, headers: standardVersionHeaders(snapshot) }
    ));
  }

  getStandardTranslate(urlID: string) {
    return this.http.get<StandardTranslationSnapshot>(
      this.apiURL.getStandardTranslate + urlID + STANDARD_TRANSLATE_PATH,
      { observe: HTTP_OBSERVE_RESPONSE }
    ).map(standardResponseWithVersion);
  }

  getGroupsAndPositions() {
    return this.http.get(this.apiURL.getGroupsWithPos, { observe: "response" });
  }

  getGroupsAndPositionsHead() {
    return this.http.get(this.apiURL.getGroupsWithPosHead, { observe: "response" });
  }

  getAllPrefixes() {
    return this.http.get(this.apiURL.getAllPrefixesFromAPI, {
      observe: "response"
    });
  }

  getTypesByPrefixID(prefixID: string) {
    return this.http.get(this.apiURL.getTypesByPrefixID + prefixID, {
      observe: "response"
    });
  }

  //  Specializations

  getAllSpecs() {
    return this.http.get(this.apiURL.getAllSpecs, { observe: "response" });
  }

  getSpecById(specId) {
    return this.http.get(this.apiURL.getSpecById + specId, {
      observe: "response"
    });
  }

  getLearningSpecs(useriId) {
    return this.http.get(this.apiURL.getLearningSpecsById + useriId, {
      observe: "response"
    });
  }

  getLearningSpecsProfile(useriId) {
    return this.http.get(this.apiURL.getLearningSpecsProfile + useriId, {
      observe: "response"
    });
  }

  getLearningSpecsUser(useriId) {
    return this.http.get(this.apiURL.getLearningSpecsUser + useriId, {
      observe: "response"
    });
  }

  createSpecGroup(group) {
    return this.http.post(this.apiURL.createSpecGroup, group, {
      observe: "response"
    });
  }

  createSubSpecGroup(group, parentId) {
    return this.http.post(this.apiURL.createSubSpecGroup + parentId, group, {
      observe: "response"
    });
  }

  createSpec(group, parentId) {
    return this.http.post(this.apiURL.createSpec + parentId, group, {
      observe: "response"
    });
  }

  updateSpec(spec, id) {
    return this.http.patch(this.apiURL.updateSpec + '/' + id, spec,  {
      observe: "response"
    });
  }

  updateSpecGroup(group, id) {
    return this.http.patch(this.apiURL.updateSpecGroup + id, group, {
      observe: "response"
    });
  }

  uploadSpecFile(formData: FormData, lvl_id) {
    const headers = new HttpHeaders({});
    headers.append("Content-Type", "multipart/form-data");
    return this.http.post(this.apiURL.uploadSpecFile + lvl_id, formData, {
      headers: headers,
      observe: "response"
    });
  }

  setQualificationLevel(spec_id, user_id, lvl) {
    const params = new HttpParams()
      .set("specializationId", spec_id)
      .set("level", lvl);
    const headers = new HttpHeaders({
      "Content-Type": "application/x-www-form-urlencoded"
    });
    return this.http.post(this.apiURL.setQualificationLevel + user_id, null, {
      headers: headers,
      observe: "response",
      params: params
    });
  }

  checkUserAnswers(lvl_id, testingAnswersModel) {
    return this.http.put(
      this.apiURL.checkUserAnswers + lvl_id,
      testingAnswersModel,
      { observe: "response" }
    );
  }

  deleteTempDocxFileManually(fileLink: string, snapshot: StandardVersionSnapshot): Observable<HttpResponse<Object>> {
    const params = new HttpParams().set(STANDARD_FILE_LINK_PARAM, fileLink).set(STANDARD_FILE_ID_PARAM, snapshot.id);
    return trackStandardVersion(snapshot, this.http.delete(this.apiURL.deleteTempDocxFileManually, {
      params: params, headers: standardVersionHeaders(snapshot), observe: HTTP_OBSERVE_RESPONSE
    }));
  }

  deleteTempDocxFileManuallyTemp(fileLink, sID) {
    const params = new HttpParams().set("link", fileLink).set("sid", sID);

    return this.http.delete(this.apiURL.deleteTempDocxFileManuallyTemp, {
      params: params,
      observe: "response"
    });
  }

  // UsersMolule
  getUsersList(params) {
    return this.http.post(this.apiURL.getUsers, params, {
      observe: "response"
    });
  }

  getUserInfo(id) {
    return this.http.get(this.apiURL.getUserInfo + id, {
      observe: "response"
    });
  }

  getGroups() {
    return this.http.get(this.apiURL.getGroups, {
      observe: "response"
    });
  }

  getGroupsWithDepartmentMarker() {
    return this.http.get(this.apiURL.getGroupsWithDepartmentMarker, {
      observe: "response"
    });
  }

  updateGroupDepartmentMarker(groupId: string, departmentMarkerCode: string) {
    return this.http.put<{groupId: string; departmentMarkerCode: string}>(
      this.apiURL.updateGroupDepartmentMarker + groupId + DEPARTMENT_MARKER_PATH,
      this.createDepartmentMarkerPayload(departmentMarkerCode),
      { observe: HTTP_OBSERVE_RESPONSE, headers: GROUP_SETTINGS_JSON_HEADERS }
    );
  }

  updateDepartmentPayrollCurrency(
    groupId: string,
    payrollCurrency: CurrencyCode
  ): Observable<HttpResponse<DepartmentPayrollCurrencyUpdateResponse>> {
    return this.http.put<DepartmentPayrollCurrencyUpdateResponse>(
      this.apiURL.updateGroupDepartmentPayrollCurrency + groupId + DEPARTMENT_PAYROLL_CURRENCY_PATH,
      this.createDepartmentPayrollCurrencyPayload(payrollCurrency),
      { observe: HTTP_OBSERVE_RESPONSE, headers: GROUP_SETTINGS_JSON_HEADERS }
    );
  }

  private createDepartmentMarkerPayload(departmentMarkerCode: string) {
    return {
      departmentMarkerCode: departmentMarkerCode || null
    };
  }

  private createDepartmentPayrollCurrencyPayload(payrollCurrency: CurrencyCode) {
    return {
      payrollCurrency: payrollCurrency
    };
  }

  getPositions() {
    return this.http.get(this.apiURL.getPositions, {
      observe: "response"
    });
  }

  deleteTeamScheduleBuilding(id: string): Observable<void> {
    const url = `/backend/common/group/team_building/${id}`;
    return this.http.delete<void>(url);
  }

  teamScheduleBuilding(teamBuildingDto: any): Observable<any> {
    const url = `/backend/common/group/team_building`;
    return this.http.post<any>(url, teamBuildingDto);
  }

  updateTeamScheduleBuilding(id: string, scheduleId: string): Observable<any> {
    const url = `/backend/common/group/team_building/${id}/schedule/${scheduleId}`;
    return this.http.patch<any>(url, {});
  }

  updateTeamAddUser(id: string, userId: string): Observable<any> {
    const url = `/backend/common/group/team_building/${id}/add/user/${userId}`;
    return this.http.patch<any>(url, {});
  }

  updateTeamRemoveUser(id: string, userId: string): Observable<any> {
    const url = `/backend/common/group/team_building/${id}/remove/user/${userId}`;
    return this.http.patch<any>(url, {});
  }

  getAllTeamBuilding(groupId: string): Observable<any[]> {
    const url = `/backend/common/group/${groupId}/team_building`;
    return this.http.get<any[]>(url);
  }

  checkStandardNumberUniqueness(number: string) {
    const params = new HttpParams().set('number', number);
    return this.http.get(this.apiURL.checkStandardNumberUniqueness, {
      params: params,
      observe: 'response'
    });
  }

  updateStandardNumber(standardId: string, newNumber: string) {
    const params = new HttpParams()
      .set('standardId', standardId)
      .set('newNumber', newNumber);
    return this.http.patch(this.apiURL.updateStandardNumber, null, {
      params: params,
      observe: 'response'
    });
  }

  private saveLegacyModalSettings(
    data: GeneralSetting,
  ): Observable<HttpResponse<GeneralSetting>> {
    return this.http.post(this.apiURL.legacyChangeModalSetting, data, {
      observe: "response"
    });
  }

  private loadLegacyModalSettings(): Observable<HttpResponse<GeneralSetting>> {
    return this.http.get(this.apiURL.legacyChangeModalSetting, {
      observe: "response"
    });
  }
}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/services/admin.service.ts